import { Component, OnChanges, OnInit, OnDestroy, Input, SimpleChanges } from "@angular/core"
import { Subscription } from "rxjs";
import { FormGroup, FormBuilder, FormControl } from "@angular/forms";
import * as moment from "moment"
import * as _ from "lodash"

moment.locale("pt-BR")

export interface CalendarDate {
    mDate: moment.Moment
    selected?: boolean
    today?: boolean
}

@Component({
    selector: "flow-datepicker",
    templateUrl: "./datepicker.component.html",
    styleUrls: ["./datepicker.component.scss"]
})
export class DatepickerComponent implements OnInit, OnDestroy {


    subscriptions: Array<Subscription> = []
    currentDate = moment()
    today = moment()
    month: string
    dayNames = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"]
    monthNames = ["JAN", "FEV", "MAR", "ABR", "MAI", "JUN", "JUL", "AGO", "SET", "OUT", "NOV", "DEZ"]
    weeks: CalendarDate[][] = []
    sortedDates: CalendarDate[] = []
    toogleHide: boolean = true
    themeid: number
    form: FormGroup
    infoTooltip: boolean = false

    @Input() label: string
    @Input() disabled: boolean = false
    @Input() control: FormControl
    @Input() showTip: boolean = true
    @Input() errorMessage: string = "Erro"
    @Input() selectedDates: CalendarDate[] = []

    constructor(private fb: FormBuilder) {
        this.month = this.monthNames[parseInt(this.currentDate.format('M')) - 1]
    }

    ngOnInit() {
        this.generateCalendar()

        this.form = this.fb.group({
            date: this.fb.control({ value: this.control.value, disabled: false })
        })

        this.subscriptions.push(
            this.control.valueChanges.subscribe(val => {
                if (this.form.controls['date'].value != val) {
                    this.form.controls['date'].setValue(val)
                }
            }),
            this.form.valueChanges.subscribe(val => {
                if (this.control.value != val.date) {
                    this.control.setValue(val.date)
                }
            })
        )

    }
    ngOnChanges(changes: SimpleChanges) {

        if (changes.disabled) {

            if (this.form) {
                Object.keys(this.form.controls).forEach((key: string) => {
                    this.form.controls[key][this.disabled ? 'disable' : 'enable']()
                })
            }

        }


    }
    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe())
    }
    hasSuccess(): boolean {
        return this.control.valid
    }
    hasError(): boolean {
        return this.control.invalid
    }
    onBlur(event) {
        const date = moment.utc(event.target.value, "DD-MM-YYYY")
        this.selectDate({
            today: this.isToday(date),
            selected: this.isSelected(date),
            mDate: date
        })
    }
    selectDate(date: CalendarDate): void {
        this.currentDate = moment.utc(date.mDate, "DD-MM-YYYY")
        this.form.patchValue({ date: this.currentDate.format('DD/MM/YYYY') })
        this.toogleHide = true
    }
    showInfo() {
        this.infoTooltip = !this.infoTooltip
    }
    openCalendar() {
        if (!this.disabled) {
            this.toogleHide = !this.toogleHide
        }
    }
    clearCalendar() {
        if (!this.disabled) {
            this.form.reset()
            this.toogleHide = true
        }
    }
    isToday(date: moment.Moment): boolean {
        //console.log('isToday', moment(date))
        return moment().isSame(moment(date), "day")
    }
    isSelected(date: moment.Moment): boolean {
        return (
            _.findIndex(this.selectedDates, selectedDate => {
                return moment(date).isSame(selectedDate.mDate, "day")
            }) > -1
        )
    }
    isSelectedMonth(date: moment.Moment): boolean {
        return moment(date).isSame(this.currentDate, "month")
    }
    setToday() {
        //console.log(this.today)
        this.currentDate = this.today
        this.form.patchValue({ date: this.currentDate.format("L") })
        this.generateCalendar()
        this.toogleHide = true
    }
    generateCalendar(): void {
        const dates = this.fillDates(this.currentDate)
        const weeks: CalendarDate[][] = []
        while (dates.length > 0) {
            weeks.push(dates.splice(0, 7))
        }
        this.weeks = weeks
    }
    fillDates(currentMoment: moment.Moment): CalendarDate[] {
        const firstOfMonth = moment
            .utc(currentMoment, "DD-MM-YYYY")
            .startOf("month")
            .day()

        const firstDayOfGrid = moment
            .utc(currentMoment, "DD-MM-YYYY")
            .startOf("month")
            .subtract(firstOfMonth, "days")

        const start = firstDayOfGrid.date()

        return _.range(start, start + 42).map(
            (date: number): CalendarDate => {
                const d = moment.utc(firstDayOfGrid, "DD-MM-YYYY").date(date)
                //console.log(d, this.isToday(d))
                return {
                    today: this.isToday(d),
                    selected: this.isSelected(d),
                    mDate: d
                }
            }
        )
    }
    prevMonth(): void {
        //console.log("prevMonth")
        this.currentDate = moment.utc(this.currentDate).subtract(1, "months")
        this.month = this.monthNames[parseInt(this.currentDate.format('M')) - 1]
        this.generateCalendar()
    }
    nextMonth(): void {
        //console.log("nextMonth")
        this.currentDate = moment.utc(this.currentDate).add(1, "months")
        this.month = this.monthNames[parseInt(this.currentDate.format('M')) - 1]
        this.generateCalendar()
    }
    prevYear(): void {
        //console.log("prevYear")
        this.currentDate = moment.utc(this.currentDate).subtract(1, "year")
        this.generateCalendar()
    }
    nextYear(): void {
        //console.log("nextYear")
        this.currentDate = moment.utc(this.currentDate).add(1, "year")
        this.generateCalendar()
    }
    selectInput(event) {
        event.target.select()
    }
    keyUp(event) {
        //const date = moment.utc(event.target.value, "DD/MM/YYYY");
        //console.log(moment(date, 'DD/MM/YYYY', true).isValid())
        event.target.value = event.target.value.replace(/^(\d{2})(\d{2})(\d{4})$/, '$1/$2/$3')
        this.form.controls['date'].setValue(event.target.value)
    }

}